"use strict";exports.__esModule=true;exports.default=void 0;var _cartesianAxis=require("../axis/cartesian-axis.animation");var _default={"initial.axisRefVisuals.axisRefVisualsCartesian":_cartesianAxis.axisAnimationAxis,"update.axisRefVisuals.axisRefVisualsCartesian":_cartesianAxis.axisAnimationFinal};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/axis-ref-visuals/cartesian-axis-ref.animation.js
// module id = 0jVj
// module chunks = 5